const InitialCitizen = {
    educationId: null,
    nationality: null,
    childCount: null,
    raceEthnicityId: null,
    religionId: null,
    lifeRisk: null,
    victimPicture: null,
    identificationNumber: null,
    name: null,
    sex: null,
    dtBirth: null,
    cpf: null,
    phone: null,
    email: null,
    attaches: [],
    status: "ACTIVATED",
    registrationDt: null,
    lastLoginDt: null,
    institutionId: null,
    aggressors: [],
    addresses: [],
    contactPhones: [],
    observation: null,
    autoCheckupDt: null,
    autoCheckupOk: null,
    interactiveCheckupExpired: null,
    vehicles: [],
    noApp: false,
    roleId: null,
    socialName: null,
    cityBirth: null,
    imgScr: null,
    education: null,
    raceEthnicity: null,
    religion: null,
    protectionProgram: [],
    protectiveMeasure: false,
    type: null,
    cnpj: null,
    aliasName: null,
    credentials: []
};

export default InitialCitizen;